const commonNameMinLength = 2;
const commonNameMaxLength = 100;
const emailMaxLength = 100;
const passwordMinLength = 5;
const passwordMaxLength = 50;

export function validateRequiredUserName(name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) {
    return 'Name is required.';
  }

  if (trimmed.length < commonNameMinLength || trimmed.length > commonNameMaxLength) {
    return `Name must contain between ${commonNameMinLength} and ${commonNameMaxLength} characters.`;
  }

  return null;
}

export function validateRequiredEmail(email: string): string | null {
  const trimmed = email.trim();
  if (!trimmed) {
    return 'Email is required.';
  }

  if (trimmed.length > emailMaxLength) {
    return `Email must contain no more than ${emailMaxLength} characters.`;
  }

  return null;
}

export function validateRequiredPassword(password: string): string | null {
  if (!password) {
    return 'Password is required.';
  }

  if (password.length < passwordMinLength || password.length > passwordMaxLength) {
    return `Password must contain between ${passwordMinLength} and ${passwordMaxLength} characters.`;
  }

  return null;
}
